module.exports = "/_next/static/images/14635d5d9fe7f27ef072b5266f75f2b9-dress-code-2.png";